export default class FilterHandler {
	init() {
		if (document.querySelector('#news-events [data-ajax-select="radio"] input')) {		
			const categorySelect = document.querySelectorAll('#news-events [data-ajax-select="radio"] input');
			const responseDiv = document.querySelector('#news-events [data-ajax="response"]');
			
			categorySelect.forEach(select => {
				select.addEventListener("change", function () {
					let postType = document.querySelector('#news-events [data-ajax-select="radio"] input[name="post_type"]:checked').value;
					
					let newUrl = new URL(window.location.href);
					newUrl.searchParams.set("post_type", postType);
					window.history.pushState({}, "", newUrl);
			
					fetch(ajaxData.ajaxUrl, {
						method: "POST",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded",
						},
						body: new URLSearchParams({
							action: "news_events_filter",
							post_type: postType,
						}),
					})
					.then(response => response.text())
					.then(data => {
						responseDiv.innerHTML = data;
					})
					.catch(error => console.error("Error:", error));
				});
			});
		}
		if (document.querySelector('#resources-insights [data-ajax-select="select"]')) {
			const categorySelect = document.querySelector('#resources-insights [data-ajax-select="select"]');
			const responseDiv = document.querySelector('#resources-insights [data-ajax="response"]');
		
			categorySelect.addEventListener("change", function () {
				let postType = categorySelect.value;
		
				let newUrl = new URL(window.location.href);
				newUrl.searchParams.set("tax_category", postType);
				window.history.pushState({}, "", newUrl);
		
				fetch(ajaxData.ajaxUrl, {
					method: "POST",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded",
					},
					body: new URLSearchParams({
						action: "resources_insights_filter",
						post_type: postType,
					}),
				})
				.then(response => response.text())
				.then(data => {
					responseDiv.innerHTML = data;
				})
				.catch(error => console.error("Error:", error));
			});
		}
		if (document.querySelector('#vacancies input[name="country"], #vacancies input[name="site"]')) {
			const countryCheckboxes = document.querySelectorAll('#vacancies input[name="country"]');
			const siteCheckboxes = document.querySelectorAll('#vacancies input[name="site"]');
			const responseDiv = document.querySelector('#vacancies [data-ajax="response"]');
		
			function getSelectedValues(checkboxes) {
				return Array.from(checkboxes)
					.filter(checkbox => checkbox.checked)
					.map(checkbox => checkbox.value);
			}
		
			function updateFilters() {
				let country = getSelectedValues(countryCheckboxes);
				let sites = getSelectedValues(siteCheckboxes);
		
				let newUrl = new URL(window.location.href);
				newUrl.searchParams.delete("site"); // Remove previous site params
				newUrl.searchParams.delete("country");
		
				if (country.length > 0) {
					newUrl.searchParams.set("country", country.join(",")); // Keep country as a comma-separated value
				}
		
				// Append each site separately
				sites.forEach(site => {
					newUrl.searchParams.append("site", site);
				});
		
				window.history.pushState({}, "", newUrl);
		
				fetch(ajaxData.ajaxUrl, {
					method: "POST",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded",
					},
					body: new URLSearchParams({
						action: "vacancy_filters",
						country: country.join(","), // Keep country as a comma-separated value
						site: sites, // Send site as an array
					}),
				})
				.then(response => response.text())
				.then(data => {
					responseDiv.innerHTML = data;
				})
				.catch(error => console.error("Error:", error));
			}
		
			countryCheckboxes.forEach(checkbox => checkbox.addEventListener("change", updateFilters));
			siteCheckboxes.forEach(checkbox => checkbox.addEventListener("change", updateFilters));
		}
		if (document.getElementById('ajax-search')) {
			const searchForm = document.getElementById('ajax-search');
			const searchInput = document.getElementById('search-input');
			const resultsContainer = document.querySelector('[data-ajax="response"]');
			const postType = document.getElementById("search-post-type");
			
			searchForm.addEventListener('submit', function (event) {
				event.preventDefault();
				let query = searchInput.value.trim();
				if (query.length > 0) {
					updateResults(query);
				}
			});
			
			function updateResults(searchQuery = "") {
				let formData = new FormData();
				formData.append("action", "ajax_search");
				formData.append("search_query", searchQuery);
				formData.append("post_type", postType.value.trim());
			
				fetch(ajaxData.ajaxUrl, {
					method: "POST",
					body: formData
				})
				.then(response => response.text())
				.then(data => {
					resultsContainer.innerHTML = data;
				})
			}
		}
	}
}